<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="top-level-container">
  <angular-editor class="angular-editor" [ngModel]="(scoringModel$ | async)?.rightSideHtmlBlock" [config]="editorConfig"></angular-editor>
</div>
